// extracted by mini-css-extract-plugin
export default {"container":"container-module__[local]___g7vap"};